export default {
    comum: {
        defaultLoadingMessage: 'Carregando...',
        rota: {
            origem: 'Inicial',
        },
        page: {
            title: '',
            subtitle: '',
            requiresAuth: null
        },
        nomeSistema: 'Odonto Delta',
        usuarioLogado: {
            empresa: {
                id: 0
            }
        },
        isGlobalLoadingEnabled: true,
        isLoading: false,
        loadingMessage: 'Por favor, aguarde...',
        timezone: 'America/Campo_Grande',
        offset: '-04:00',
        redirectPage: null
    },
    notificacao: {
        cor: '',
        titulo: '',
        mensagem: '',
        mostrar: false,
        eventoClick: null
    },

}
